import { productGroupSelectors } from 'src/app/features/product/product-group/product-group.selectors'
import { persistentUserRoleSelectors } from 'src/app/features/role/user-role/persistent-user-role/persistent-user-role.selector'
import { settingSelectors } from 'src/app/core/settings/settings.selectors'
import { UserRole } from 'src/app/features/role/user-role/user-role'
import { configurationOptionSelectors } from 'src/app/features/configuration-option/configuration-option.selectors'
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core'
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { Store } from '@ngrx/store'
import { AppState } from '../../../../core/core.state'
import { productActions } from '../../../product/product.actions'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { productSelectors } from '../../../product/product.selectors'
import { markFormGroupDirty } from '../../../../shared/utils/mark-form-dirty'
import {
  catchError,
  distinctUntilChanged,
  filter,
  map,
  startWith,
  switchMap,
  take,
  tap,
  withLatestFrom
} from 'rxjs/operators'
import { SaleItem } from '../sale-item'
import { bookableSlotActions } from '../../../bookable-slot/bookable-slot.actions'
import moment from 'moment-mini'
import { Moment } from 'moment-mini'
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs'
import { CalendarEvent } from '../../../../shared/components/calendar/event'
import { bookableSlotSelectors } from '../../../bookable-slot/bookable-slot.selectors'
import { participationSelectors } from '../../../booking/participation/participation.selectors'
import { CalendarService } from '../../../../shared/components/calendar/calendar.service'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { ConfigurationService } from '../../../../shared/services/configuration.service'
import { SaleItemPurchaseParamsFormComponent } from '../form-purchase-params/form.component'
import { authSelectors } from '../../../../core/auth/auth.selectors'
import { bookingActions } from '../../../booking/booking.actions'
import { bookingSelectors } from '../../../booking/booking.selectors'
import { Product } from 'src/app/features/product/product'
import { Dictionary } from '@ngrx/entity'
import { BookableSlot } from 'src/app/features/bookable-slot/bookable-slot'
import { Booking } from 'src/app/features/booking/booking'
import { saleSelectors } from '../../sale.selectors'
import { NotificationService } from 'src/app/core/notification.service'
import { OnDestroy, ChangeDetectorRef } from '@angular/core'
import { environment } from 'src/environments/environment'
import { Actions, ofType } from '@ngrx/effects'
import { productGroupActions } from 'src/app/features/product/product-group/product-group.actions'
import { TranslateService } from '@ngx-translate/core'
import { TypeOfProduct } from 'src/app/shared/constants'
import { SaleItemSurveyDraft } from '../../sale-item-survey-draft/sale-item-survey-draft.model'
import { SaleItemCreateFormState } from '../create-form-state.model'

type BookingOption = 'showCalendar' | 'createBooking'
export interface SaleItemFormCreateSubmit {
  saleItem: Partial<SaleItem>
  surveyDraft?: Partial<SaleItemSurveyDraft> | null
}

@UntilDestroy()
@Component({
  selector: 'sale-item-form-create',
  templateUrl: 'form.component.html',
  styleUrls: ['./form.component.scss']
})
export class SaleItemFormCreateComponent implements OnInit, OnDestroy {
  @Output() onSubmit = new EventEmitter<SaleItemFormCreateSubmit>()
  @Output() formStateChange = new EventEmitter<SaleItemCreateFormState>()
  @Input() customerCategoryId: any
  @Input() saleId: any
  @Input() loading: any = false
  @Input() typeProduct: string
  @ViewChild('salesItemsPurchase')
  saleItemPurchaseParamsFormComponent: SaleItemPurchaseParamsFormComponent
  public showSaveButton = true

  public defaultSelected: number
  public form: UntypedFormGroup
  public bookingForm: UntypedFormGroup
  public resetForm$: BehaviorSubject<boolean> = new BehaviorSubject(false)
  public calendarEvents$: Observable<CalendarEvent[]>
  public bookableProducts$: Observable<Product[]>
  public products$: Observable<Product[]>
  public selectedProduct$: Observable<Product>
  public isProductBookableOrActivity$: Observable<boolean>
  public isProductBookable$: Observable<boolean>
  public showCalendar$: Observable<boolean>
  public showCreateBooking$: Observable<boolean>
  public shouldShowCalendar$: Observable<boolean>
  public selectedBookableSlot$: Observable<BookableSlot>
  public selectedBookableSlot: boolean = false
  public productEntities$: Observable<Dictionary<Product>>
  public bookings$: Observable<Booking[]>
  public parentBookableProducts$: Observable<any[]>
  //public parentBookableProducts$: Subject<Product[]> = new Subject<Product[]>()
  public bookableSlotParams$: Observable<BookableSlot>
  public maxGuestInvite: number
  public maxGuestError: boolean
  public bookingPreSelected: number
  public isLoading: boolean = true
  public isLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false)
  public selectedBookableSlotDate
  public categories$: Observable<string[]>
  public selectedLanguage$: Observable<string>
  public currentUserRole$: Observable<UserRole>
  private currentUserRole: UserRole
  private ticketingProductGroupId: number[]
  public chooseCategoryAllowed$: Observable<boolean>
  public isResource: boolean = false
  public surveySubmitAttempted = false
  public currentSurveyDraft: Partial<SaleItemSurveyDraft> | null = null
  public isSurveyLoading = false
  constructor(
    private fb: UntypedFormBuilder,
    private actions$: Actions,
    private store: Store<AppState>,
    private calendarService: CalendarService,
    public config: ConfigurationService,
    private chd: ChangeDetectorRef,
    private notificationService: NotificationService,
    private translateService: TranslateService
  ) {}

  public get bookingOption(): BookingOption {
    return this.form.get('bookingOption').value
  }

  public get isSurveyBlockingSave(): boolean {
    return Boolean(
      this.isSurveyLoading ||
        (this.currentSurveyDraft?.hasSurvey && !this.currentSurveyDraft?.isValid)
    )
  }
  ngOnDestroy(): void {
    this.store.dispatch(bookableSlotActions.setSelected({ entity: null }))
  }
  ngOnInit() {
    this.isLoading = false
    this.isLoading$.next(true)
    this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'ticketing_product_group_id'
      )
      .pipe(
        filter((x) => Boolean(x?.value)),
        take(1)
      )
      .subscribe((configOpt) => {
        const ticketingGroupIds = JSON.parse(configOpt.value)
        if (!ticketingGroupIds?.length) {
          return
        }

        this.store.dispatch(
          productGroupActions.fetchMany({
            params: RequestQueryBuilder.create({
              search: { id: { [CondOperator.IN]: ticketingGroupIds } },
              join: [{ field: 'products' }]
            })
          })
        )
        this.ticketingProductGroupId = [...ticketingGroupIds]
      })

    this.selectedLanguage$ = this.store.select(
      settingSelectors.selectById,
      'language'
    )
    this.currentUserRole$ = this.store.select(
      persistentUserRoleSelectors.selectSelectedUserRole
    )

    this.currentUserRole$
      .pipe(untilDestroyed(this))
      .subscribe(
        (currentUserRole) =>
          (this.currentUserRole =
            currentUserRole && currentUserRole.siteId
              ? currentUserRole
              : { ...currentUserRole, siteId: environment.defaultSiteId })
      )
    this.categories$ = this.selectedLanguage$.pipe(
      switchMap((language) => {
        return this.store.select(configurationOptionSelectors.selectAll).pipe(
          map((categories) => {
            let categoriesOptions = []
            for (let category = 0; category < 10; category++) {
              const categoryDescription = categories.find(
                (cat) =>
                  cat.key === `${language}_category${category}desc` &&
                  (cat.siteId === this.currentUserRole?.siteId ||
                    !cat.siteId) &&
                  cat.value?.length
              )
              categoryDescription
                ? categoriesOptions.push(categoryDescription)
                : null
            }
            let mappedCategeries = JSON.parse(JSON.stringify(categoriesOptions))
            mappedCategeries.map((item) => {
              if (Number(item.siteId) != 0 && !item.siteId) {
                item.siteId = this.currentUserRole.siteId
              }
            })
            categoriesOptions = JSON.parse(JSON.stringify(mappedCategeries))
            return categoriesOptions
          }),
          map((configOptions) => {
            let nCategories = environment.moduleConfigs.hasExtendedCategories
              ? 9
              : 4
            return configOptions
              .filter(
                (c, i) =>
                  (c.siteId == this.currentUserRole?.siteId &&
                    i <= nCategories) ||
                  (!c.siteId && i <= nCategories)
              )
              .map((option) => option.key)
              .map((key) => key.split(language + '_').pop())
          })
        )
      })
    )
    this.store.dispatch(
      productActions.fetchMany({
        params: RequestQueryBuilder.create({
          join: [
            { field: 'parentBookableProducts' },
            { field: 'linkedSubscriptions' },
            { field: 'surveyParents' }
          ]
        })
      })
    )
    this.form = this.fb.group({
      productId: [null, [Validators.required]],
      quantity: [1, [Validators.min(1)]],
      customerCategory: [null, []],
      bookingId: [null, []],
      bookableProductId: [null, []],
      parentBookableProductsIds: [null, []],
      // handle radio state for calendar, remove before submit the form
      bookingOption: ['showCalendar', []], // or createBooking
      startDate: [null, []],
      endDate: [null, []],
      startTime: [null, []],
      endTime: [null, []]
    })

    this.form.statusChanges
      .pipe(startWith(this.form.status), untilDestroyed(this))
      .subscribe(() => this.emitFormState())

    this.isLoading$
      .pipe(untilDestroyed(this))
      .subscribe(() => this.emitFormState())

    this.bookingForm = this.fb.group({
      bookableProductId: [null, []],
      bookableLinkedProductId: [null, []],
      invitedGuests: [null, []]
    })

    if (!this.isResource && this.typeProduct === TypeOfProduct.BOOKING) {
      this.form.controls['parentBookableProductsIds'].setValidators(
        Validators.required
      )
      this.form.controls['parentBookableProductsIds'].updateValueAndValidity()
    }

    // observables
    this.products$ = this.store.select(productSelectors.selectAll).pipe(
      map((products) => {
        return products.filter((product) => {
          if (!product?.isActive) {
            return false
          }
          if (this.typeProduct) {
            if (this.typeProduct === TypeOfProduct.BOOKING) {
              return !product?.allowAsLinkedProduct && !product?.bookable
                ? false
                : true
            }
            if (this.typeProduct === TypeOfProduct.OTHERPRODUCT) {
              return !product?.allowAsLinkedProduct && !product?.bookable
            }
          } else {
            return true
          }
        })
      })
    )

    this.bookableProducts$ = this.store
      .select(productSelectors.selectAll)
      .pipe(map((products) => products.filter((p) => p.bookable)))

    // Form observables
    this.selectedProduct$ = this.form.get('productId').valueChanges.pipe(
      filter((productId) => !!productId),
      // get current selected productId from store
      switchMap((productId) =>
        this.store.select(productSelectors.selectById, productId)
      ),

      tap((product) => {
        // defaultStartTime

        if (!isNaN(Date.parse('2020-01-01 ' + product.defaultStartTime))) {
          const date = moment('2020-01-01 ' + product.defaultStartTime)
            .startOf('minute')
            .toDate()
          this.form.get('startTime').setValue(date)
        }
        // defaultEndTime
        if (!isNaN(Date.parse('2020-01-01 ' + product.defaultEndTime))) {
          const date = moment('2020-01-01 ' + product.defaultEndTime)
            .startOf('minute')
            .toDate()
          this.form.get('endTime').setValue(date)
        }
      })
    )
    if (this.typeProduct === TypeOfProduct.BOOKING) {
      this.selectedBookableSlot$ = this.store.select(
        bookableSlotSelectors.selectSelected
      )
    } else {
      this.selectedBookableSlot$ = of(null)
    }

    this.selectedBookableSlot$
      ?.pipe(
        take(1),
        tap((bookingSelected) => {
          if (bookingSelected) {
            this.bookingPreSelected = bookingSelected.bookingId
            this.selectedProduct$ = this.store.select(
              productSelectors.selectById,
              bookingSelected.linkedProductId ??
                bookingSelected.bookableProductId ??
                bookingSelected.bookingId
            )
            this.form.controls['parentBookableProductsIds'].setValidators([])
            this.form.controls[
              'parentBookableProductsIds'
            ].updateValueAndValidity()
            this.selectedProduct$.pipe(take(1)).subscribe((product) => {
              this.form
                .get('productId')
                .patchValue(
                  bookingSelected.linkedProductId ??
                    bookingSelected.bookableProductId ??
                    bookingSelected.bookingId
                )
              this.store
                .select(bookingSelectors.selectById, this.bookingPreSelected)
                .pipe(untilDestroyed(this))
                .subscribe((booking) => {
                  this.form.get('startDate').setValue(booking.startDate)
                  this.form.get('endDate').setValue(booking.endDate)
                })
            })
          }
        })
      )
      .subscribe()
    this.isProductBookableOrActivity$ = this.selectedProduct$.pipe(
      map((product) => {
        return (
          Boolean(product.bookable) || Boolean(product.allowAsLinkedProduct)
        )
      })
    )

    this.isProductBookable$ = this.selectedProduct$.pipe(
      map((product) => Boolean(product.bookable))
    )

    this.showCalendar$ = this.form.get('bookingOption').valueChanges.pipe(
      startWith('showCalendar' as BookingOption),
      map((option) => option === ('showCalendar' as BookingOption))
    )

    this.showCreateBooking$ = this.form
      .get('bookingOption')
      .valueChanges.pipe(
        map((option) => option === ('createBooking' as BookingOption))
      )
    this.isProductBookableOrActivity$
      .pipe(untilDestroyed(this))
      .subscribe((showCalendar) => {
        if (
          showCalendar &&
          this.form.get('bookingOption').value === 'showCalendar'
        ) {
          if (!moment(this.form.controls['startDate'].value).isValid()) {
            this.form.removeControl('startDate')
            this.form.addControl(
              'startDate',
              this.fb.control(null, [
                Validators.required,
                Validators.minLength(5),
                this.dateValidator
              ])
            )
            this.form.controls['startDate'].setValue(null)
          }
          if (!moment(this.form.controls['endDate'].value).isValid()) {
            this.form.removeControl('endDate')
            this.form.addControl(
              'endDate',
              this.fb.control(null, [
                Validators.required,
                Validators.minLength(5),
                this.dateValidator
              ])
            )
            this.form.controls['endDate'].setValue(null)
          }
        }
      })
    this.showCreateBooking$
      .pipe(untilDestroyed(this))
      .subscribe((bookingOption: any) => {
        if (bookingOption) {
          this.form.removeControl('startDate')
          this.form.addControl(
            'startDate',
            this.fb.control(null, [
              Validators.required,
              Validators.minLength(5),
              this.dateValidator
            ])
          )
          this.form.controls['startDate'].setValue(null)
          this.form.removeControl('endDate')
          this.form.addControl('endDate', this.fb.control(null, []))
          this.form.controls['endDate'].setValue(null)
        } else {
          this.form.removeControl('startDate')
          this.form.addControl(
            'startDate',
            this.fb.control(null, [
              Validators.required,
              Validators.minLength(5),
              this.dateValidator
            ])
          )
          this.form.controls['startDate'].setValue(null)
          this.form.removeControl('endDate')
          this.form.addControl(
            'endDate',
            this.fb.control(null, [
              Validators.required,
              Validators.minLength(5),
              this.dateValidator
            ])
          )
          this.form.controls['endDate'].setValue(null)
        }
      })

    this.shouldShowCalendar$ = combineLatest([
      this.showCalendar$,
      this.selectedBookableSlot$
    ]).pipe(
      map(([showCalendar, selectedBookableSlot]) => {
        return showCalendar && !selectedBookableSlot
      })
    )
    if (this.typeProduct === TypeOfProduct.BOOKING) {
      this.bookableSlotParams$ = this.selectedBookableSlot$?.pipe(
        filter((bookableSlot) => !!bookableSlot),
        map((bookableSlot) => ({
          ...bookableSlot,
          bookableLinkedProductId: bookableSlot.linkedProductId
        }))
      )
    }
    this.productEntities$ = this.store.select(productSelectors.selectEntities)
    this.bookings$ = this.store.select(bookingSelectors.selectAll)

    this.parentBookableProducts$ = combineLatest([
      this.selectedProduct$,
      this.productEntities$,
      this.bookings$,
      this.selectedBookableSlot$,
      this.store.select(productSelectors.selectAll)
    ]).pipe(
      map(
        ([
          product,
          productEntities,
          bookings,
          selectedBookableSlot,
          allProducts
        ]) => {
          if (
            !this.saleId ||
            (this.saleId && !this.showSaveButton) ||
            (this.saleId && !!product && !selectedBookableSlot)
          ) {
            let arrayProductIds = []

            if (!product) {
              arrayProductIds = []
            }
            if (this.isResource) {
              arrayProductIds = allProducts
                .filter(
                  (prodct) =>
                    prodct.parentBookableProducts?.includes(product.id) &&
                    prodct.availableFromDate &&
                    prodct?.isActive
                )
                .map((item) => productEntities[item.id])
                .sort((a, b) => a.description.localeCompare(b.description))
            } else if (!this.isResource) {
              arrayProductIds = product?.parentBookableProducts
                ?.filter((id) => productEntities[id]?.isActive)
                ?.map((id) => productEntities[id])
                ?.sort((a, b) => a.description.localeCompare(b.description))
            }

            return arrayProductIds
          }
          const startDate = selectedBookableSlot?.startDate

          if (
            !product?.allowAsLinkedProduct &&
            !product?.bookable &&
            product?.isActive
          ) {
            return product?.parentBookableProducts
              ?.filter(
                (parentBookableProductId) =>
                  bookings.find(
                    (booking) => booking.productId === parentBookableProductId
                  ) && productEntities[parentBookableProductId]?.isActive
              )
              .map((id) => productEntities[id])
              .sort((a, b) => a.description.localeCompare(b.description))
          }
          const bookingsAtDate = bookings.filter(
            (booking) =>
              moment(startDate).isSameOrAfter(
                moment(booking.startDate),
                'day'
              ) &&
              moment(startDate).isSameOrBefore(moment(booking.endDate), 'day')
          )

          return product?.parentBookableProducts
            ?.filter(
              (parentBookableProductId) =>
                !bookingsAtDate.find(
                  (booking) => booking.productId === parentBookableProductId
                ) && productEntities[parentBookableProductId]?.isActive
            )
            .map((id) => productEntities[id])
            .sort((a, b) => a.description.localeCompare(b.description))
        }
      )
    )

    this.setupCalendarFetching()
    this.setupCalendarEvents()
    this.selectedBookableSlot = this.haveSelectedBookableSlot()
    this.store.select(authSelectors.selectMember).subscribe((member) => {
      if (member) {
        this.form.get('customerCategory').setValue(member.category)
      }
    })
    if (this.customerCategoryId !== 0 && this.saleId) {
      this.form.get('customerCategory').setValue(this.customerCategoryId)
    }
    if (!this.saleId) {
      this.store
        .select(saleSelectors.selectPartial)
        .pipe(take(1))
        .subscribe((partial: any) => {
          this.form.get('customerCategory').setValue(partial.customerCategory)
        })
    }

    combineLatest([this.selectedProduct$, this.selectedBookableSlot$])
      .pipe(
        untilDestroyed(this),
        distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b)),
        filter(
          ([product, selectedBookableSlot]) =>
            !!product && !!selectedBookableSlot
        )
      )
      .subscribe(([product, selectedBookableSlot]) => {
        const startDate = selectedBookableSlot?.startDate
        this.form.get('startDate').setValue(startDate)
        this.store.dispatch(
          bookingActions.fetchMany({
            params: RequestQueryBuilder.create({
              search: {
                startDate: moment(startDate).isValid()
                  ? {
                      [CondOperator.BETWEEN]: [
                        moment(startDate).startOf('day').toISOString(),
                        moment(startDate).endOf('day').toISOString()
                      ]
                    }
                  : {},
                productId: {
                  [CondOperator.IN]: [
                    product.id,
                    ...(product.parentBookableProducts
                      ? product.parentBookableProducts
                      : [])
                  ]
                }
              },
              join: [{ field: 'participations' }]
            })
          })
        )
      })

    this.store
      .select(bookingSelectors.selectAll)
      .pipe(
        filter((bookings) => !!bookings.length),
        take(1),
        untilDestroyed(this)
      )
      .subscribe(() => {
        this.isLoading$.next(false)
      })

    this.chooseCategoryAllowed$ = combineLatest([
      this.store.select(productGroupSelectors.selectAll),
      this.selectedProduct$
    ]).pipe(
      map(([productGroups, selectedProduct]) => {
        const ticketingProductGroups = productGroups.filter((productGroup) =>
          this.ticketingProductGroupId.includes(productGroup.id)
        )

        const products = ticketingProductGroups
          .map((productGroup) => productGroup.products)
          .flat()
          .filter(Boolean)

        return (
          products?.includes(selectedProduct.id) ||
          selectedProduct?.allowChooseCategory
        )
      })
    )
  }

  private dateValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (!moment(control.value).isValid()) {
      return { dateNotValid: true }
    }

    return null
  }
  public disabledHours(date: Date): () => number[] {
    if (!date) {
      return null
    }
    return () => {
      const hours = Array(24)
        .fill(0)
        .map((_, i) => i)
      return hours.filter((h) => h <= date.getHours())
    }
  }

  public onFormSubmit() {
    this.isLoading = true
    this.surveySubmitAttempted = true
    this.emitFormState()
    if (this.saleItemPurchaseParamsFormComponent) {
      this.form.addControl(
        'params',
        this.saleItemPurchaseParamsFormComponent.form
      )
      this.saleItemPurchaseParamsFormComponent.form.setParent(this.form)
    }

    const createBookingForm =
      this.form.get('bookingOption').value === 'createBooking'
    const showCalendar = this.form.get('bookingOption').value === 'showCalendar'

    if (createBookingForm) {
      this.form.removeControl('params')
      this.form.addControl('params', this.bookingForm)
      this.bookingForm.setParent(this.form)
    }

    markFormGroupDirty(this.form)

    if (this.customerCategoryId && this.customerCategoryId !== 0) {
      this.form.get('customerCategory').setValue(this.customerCategoryId)
    }

    const { productId, quantity, customerCategory, bookingId, params } =
      this.form.value

    if (showCalendar) {
      let paramControls = this.form.controls['params'] as UntypedFormGroup

      if (params?.invitedMemberEmails?.length !== 0) {
        params.invitedMemberEmails.map((data, index) => {
          if (data.email == undefined || data.email == null) {
            this.form.markAsDirty()
            this.form.setErrors({ invalid: true })
          }
        })
      }

      this.productEntities$
        ?.pipe(
          take(1),
          withLatestFrom(this.store.select(bookingSelectors.selectEntities))
        )
        .subscribe(([productEntities, bookingEntities]) => {
          let categoryInvites = 0
          for (let category = 0; category < 10; category++) {
            categoryInvites += params[`invitedCategory${category}`]?.length
          }

          if (
            (!productEntities[params.bookableLinkedProductId]
              ?.spreadParticipantsOverResources &&
              categoryInvites +
                (productEntities[params.bookableLinkedProductId]
                  ?.bookerMustBeParticipant
                  ? 1
                  : 0) +
                params.invitedGuests.length +
                params.invitedOthers.length +
                params.invitedMemberEmails.length <
                productEntities[params.bookableLinkedProductId]
                  ?.minParticipants) ||
            (productEntities[params.bookableLinkedProductId]
              ?.spreadParticipantsOverResources &&
              !bookingEntities[bookingId].currentParticipantCount &&
              !bookingEntities[bookingId].participations?.length &&
              categoryInvites +
                (productEntities[params.bookableLinkedProductId]
                  ?.bookerMustBeParticipant
                  ? 1
                  : 0) +
                params.invitedGuests.length +
                params.invitedOthers.length +
                params.invitedMemberEmails.length <
                productEntities[params.bookableLinkedProductId]
                  ?.minParticipants)
          ) {
            this.notificationService.emit(
              'alerts.errorMinParticipantsNotEnough',
              'error'
            )
            this.form.setErrors({ invalid: true })
            return
          }
        })
    }
    if (!this.form.valid) {
      this.form.markAsDirty()
      //this.form.setErrors(null)

      this.isLoading = false
      this.emitFormState()

      return
    }

    if (this.currentSurveyDraft?.hasSurvey && !this.currentSurveyDraft?.isValid) {
      this.isLoading = false
      this.emitFormState()
      return
    }

    const saleItem = {
      id: Date.now() + Math.floor(Math.random() * 1000),
      productId,
      quantity,
      customerCategory: Number(customerCategory),
      bookingId,
      params,
      typeProduct: this.typeProduct
    }

    if (saleItem?.params && !saleItem?.params.bookableLinkedProductId) {
      saleItem.params.bookableLinkedProductId = saleItem.productId
    }
    if (saleItem.params?.invitedMemberEmails) {
      saleItem.params.invitedMemberEmails =
        saleItem.params?.invitedMemberEmails.map((control) => control.email)
    }
    if (!createBookingForm && this.saleItemPurchaseParamsFormComponent) {
      saleItem.params.bookableProductId =
        this.form.get('bookableProductId').value

      const startDate = moment(this.form.get('startDate').value)

      startDate.set({ second: 0, millisecond: 0 })

      saleItem.params.startDate = startDate.toISOString()
      saleItem.params.endDate = this.form.get('endDate').value
    }

    if (createBookingForm) {
      delete saleItem?.params?.startTime
      saleItem.params.bookableLinkedProductId = saleItem.productId

      saleItem.params.bookableProductId =
        this.form.get('bookableProductId').value

      const invitedGuests = this.bookingForm.get('invitedGuests').value
      saleItem.params.invitedGuests = !invitedGuests
        ? []
        : [...Array(invitedGuests)].map((i) => ({}))
    }

    if (
      createBookingForm ||
      !this.saleItemPurchaseParamsFormComponent ||
      this.saleId
    ) {
      const params = saleItem.params ?? {}
      // add default start time
      const startTime = this.form.get('startTime').value
      const endTime = this.form.get('endTime').value
      const startDate = this.form.get('startDate').value
      if (startTime && startDate) {
        const startTimeMoment = moment(startTime)
        params.startDate = moment(startDate).set({
          hour: startTimeMoment.get('hour'),
          minute: startTimeMoment.get('minute'),
          second: startTimeMoment.get('second')
        })
      }
      if (endTime && startDate) {
        const endTimeMoment = moment(endTime)
        // const endTimeMoment = moment(endTime)
        params.endDate = moment(startDate).set({
          hour: endTimeMoment.get('hour'),
          minute: endTimeMoment.get('minute'),
          second: endTimeMoment.get('second')
        })
      }

      if (this.form.value.bookableProductId) {
        params.bookableProductId = this.form.value.bookableProductId
      }

      saleItem.params = {
        ...params
      }
    }
    this.isLoading = false
    this.emitFormState()

    if (this.bookingPreSelected) {
      saleItem.bookingId = this.bookingPreSelected
    }
    this.maxGuestError = false

    this.onSubmit.emit({
      saleItem,
      surveyDraft: this.currentSurveyDraft?.hasSurvey
        ? {
            ...this.currentSurveyDraft,
            bookingId: saleItem.bookingId ?? this.currentSurveyDraft?.bookingId,
            bookableProductId:
              saleItem.params?.bookableProductId ??
              this.currentSurveyDraft?.bookableProductId,
            bookableLinkedProductId:
              saleItem.params?.bookableLinkedProductId ??
              saleItem.productId ??
              this.currentSurveyDraft?.bookableLinkedProductId
          }
        : null
    })
  }

  public onSurveyDraftChange(draft: Partial<SaleItemSurveyDraft>) {
    this.currentSurveyDraft = draft
    this.emitFormState()
  }

  public onSurveyLoadingChange(isLoading: boolean) {
    this.isSurveyLoading = isLoading
    this.emitFormState()
  }

  public onSearchProducts(term: string) {
    this.store.dispatch(
      productActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: {
            description: { [CondOperator.CONTAINS_LOW]: term },
            isActive: 1
          },
          join: [
            { field: 'translations' },
            { field: 'parentBookableProducts' },
            { field: 'linkedSubscriptions' },
            { field: 'surveyParents' }
          ]
        })
      })
    )
  }

  private fetchSelectedProduct(product) {
    if (
      !this.isResource &&
      product.parentBookableProducts &&
      product.parentBookableProducts.length > 0
    ) {
      this.store.dispatch(
        productActions.fetchMany({
          params: RequestQueryBuilder.create({
            search: {
              id: { [CondOperator.IN]: [...product.parentBookableProducts] },
              isActive: 1
            },
            join: [
              { field: 'translations' },
              { field: 'parentBookableProducts' },
              { field: 'linkedSubscriptions' },
              { field: 'surveyParents' }
            ]
          })
        })
      )
    }
    if (this.isResource) {
      this.store.dispatch(
        productActions.fetchMany({
          params: RequestQueryBuilder.create({
            search: {
              'parentBookableProducts.id': {
                [CondOperator.CONTAINS]: product.id
              },
              isActive: 1
            },
            join: [
              { field: 'translations' },
              { field: 'parentBookableProducts' },
              { field: 'linkedSubscriptions' },
              { field: 'surveyParents' }
            ]
          })
        })
      )
    }
  }
  public setBookingOption(option) {
    if (option == 'showCalendar') {
      this.resetForm$.next(true)
      this.showSaveButton = true
    } else {
      this.showSaveButton = false
      if (this.form.controls['productId'].value) {
        this.productEntities$
          .pipe(take(1))
          .subscribe((productEntities) =>
            this.fetchSelectedProduct(
              productEntities[this.form.controls['productId'].value]
            )
          )
      }
    }

    this.form.get('bookingOption').setValue(option)
    this.emitFormState()
  }
  public productSelected(product: Product) {
    this.isResource =
      product.bookable && !product.allowAsLinkedProduct ? true : false
    if (!this.isResource && this.typeProduct === TypeOfProduct.BOOKING) {
      this.form.controls['parentBookableProductsIds'].setValidators(
        Validators.required
      )
      this.form.controls['parentBookableProductsIds'].updateValueAndValidity()
    } else {
      this.form.controls['parentBookableProductsIds'].setValidators([])
      this.form.controls['parentBookableProductsIds'].updateValueAndValidity()
    }

    this.fetchSelectedProduct(product)
    this.maxGuestInvite = product.maxGuestInvites
  }

  public onChangeDates(event: { startDate: Moment; endDate: Moment }) {
    this.fetchBookableSlots(
      event.startDate.toDate(),
      event.endDate.toDate(),
      this.form.get('productId').value
    )
  }

  public createBooking() {
    this.store
      .select(persistentUserRoleSelectors.selectSelectedUserRole)
      .pipe(take(1))
      .subscribe((pUr) => {
        this.productEntities$.pipe(take(1)).subscribe((prodEntities) => {
          const siteId = pUr && pUr.siteId ? pUr.siteId : 0
          const startTime = moment(
            this.form.controls['startTime'].value
          ).format('HH:mm')
          const endTime = moment(this.form.controls['endTime'].value).format(
            'HH:mm'
          )
          const starDate = moment(this.form.controls['startDate'].value)
            .set('hour', Number(startTime.split(':')[0]))
            .set('minutes', Number(startTime.split(':')[1]))
          // const endTimeMoment =
          //   Number(endTime.split(':')[1]) == 0
          //     ? `${(Number(endTime.split(':')[0]) - 1).toString()}:59`
          //     : Number(endTime.split(':')[1]) == 30
          //     ? `${endTime.split(':')[0]}:29`
          //     : endTime
          const endDate = moment(this.form.controls['startDate'].value)
            .set('hour', Number(endTime.split(':')[0]))
            .set('minutes', Number(endTime.split(':')[1]))

          if (!this.isResource) {
            this.store.dispatch(
              bookingActions.createManyWithOneMinuteLess({
                entities: this.form.controls[
                  'parentBookableProductsIds'
                ].value.map((item) => ({
                  linkedProductId: this.form.controls['productId'].value,
                  productId: item,
                  siteId: siteId,
                  maxParticipants:
                    prodEntities[this.form.controls['productId'].value]
                      .maxParticipants,
                  productIds:
                    this.form.controls['parentBookableProductsIds'].value,
                  startDate: moment(starDate).seconds(0),
                  endDate: moment(endDate).seconds(0)
                }))
              })
            )
          } else {
            this.store.dispatch(
              bookingActions.createManyWithOneMinuteLess({
                entities: [
                  this.form.controls['parentBookableProductsIds'].value
                ].map((item) => ({
                  linkedProductId: item,
                  productId: this.form.controls['productId'].value,
                  siteId: siteId,
                  maxParticipants:
                    prodEntities[this.form.controls['productId'].value]
                      .maxParticipants,
                  productIds: [
                    this.form.controls['parentBookableProductsIds'].value
                  ],
                  startDate: moment(starDate).seconds(0),
                  endDate: moment(endDate).seconds(0)
                }))
              })
            )
          }
          this.actions$
            .pipe(
              ofType(bookingActions.upsertMany),
              take(1),
              catchError((error) => {
                return of(null)
              })
            )
            .subscribe((action) => {
              this.store.dispatch(
                bookingActions.fetchMany({
                  params: RequestQueryBuilder.create({
                    search: {
                      startDate: {
                        [CondOperator.BETWEEN]: [
                          moment(starDate).startOf('day').toISOString(),
                          moment(endDate).endOf('day').toISOString()
                        ]
                      }
                    },
                    join: [{ field: 'participations' }]
                  })
                })
              )
              this.fetchBookableSlots(
                starDate.subtract(1, 'day').toDate(),
                endDate.add(1, 'day').toDate(),
                this.form.controls['productId'].value
              )
              this.notificationService.emit('alerts.success', 'success')
            })

          this.setBookingOption('showCalendar')
        })
      })
  }
  public onClickDates(event: moment.Moment) {
    if (this.form.controls['bookingOption'].value == 'showCalendar') {
      return
    }

    this.form.controls['startDate'].patchValue(event)
    this.form.controls['startTime'].patchValue(event)
    this.form.controls['endTime'].patchValue(moment(event).add(1, 'hour'))
  }
  public onClickEvent(event: CalendarEvent) {
    this.resetForm$.next(true)
    this.setBookingOption('showCalendar')
    if (!this.isResource) {
      if (
        (event?.params?.bookableSlot?.linkedProductId &&
          event?.params?.bookableSlot?.bookableProductId &&
          event?.params?.bookableSlot?.bookingId) ||
        (event?.params?.booking &&
          event?.params?.booking?.productId &&
          event?.params?.booking?.linkedProductId)
      ) {
        this.form.controls['parentBookableProductsIds'].setValidators([])
        this.form.controls['parentBookableProductsIds'].updateValueAndValidity()
      }
      this.selectedProduct$.pipe(take(1)).subscribe((product) => {
        this.form.controls['parentBookableProductsIds'].patchValue(
          product.parentBookableProducts
        )
      })
    }
    this.showSaveButton = true
    this.emitFormState()
    const targetProductId = event.params.bookableSlot?.linkedProductId
      ? event.params.bookableSlot?.linkedProductId
      : event.params.bookableSlot?.bookableProductId
    if (this.bookingPreSelected) {
      this.bookingPreSelected = event.params.bookableSlot?.bookingId
    }
    let canBook = true
    combineLatest([
      this.store.select(productSelectors.selectEntities),
      this.store.select(bookingSelectors.selectEntities),
      this.store.select(participationSelectors.selectEntities),
      this.store.select(saleSelectors.selectPartial),
      this.translateService.get('alerts.privateBookingCantBookByMultiplePerson')
    ])
      .pipe(take(1))
      .subscribe(
        ([
          productEntities,
          bookingEntities,
          participationEntities,
          salePartial,
          alertTranslation
        ]) => {
          if (
            productEntities[targetProductId]?.isPrivateBookable &&
            bookingEntities[
              event.params.bookableSlot?.bookingId
            ]?.participations?.find(
              (participationId) =>
                participationEntities[participationId]?.memberId !=
                salePartial?.customerPersonId
            )
          ) {
            if (confirm(alertTranslation)) {
              canBook = true
            } else {
              canBook = false
            }
          }
        }
      )

    if (canBook) {
      const { startDate, endDate } = event.params.bookableSlot
      this.selectedBookableSlot = true
      this.store.dispatch(
        bookableSlotActions.setSelected({ entity: event.params.bookableSlot })
      )
      // set value for bookingId
      this.form.get('bookingId').setValue(event.params.bookableSlot.bookingId)

      this.selectedProduct$ = this.store.select(
        productSelectors.selectById,
        event.params.bookableSlot.linkedProductId ??
          event.params.bookableSlot.bookableProductId ??
          event.params.bookableSlot.bookingId
      )
      this.form
        .get('bookableProductId')
        .setValue(event.params.bookableSlot.bookableProductId)

      this.selectedBookableSlotDate = startDate
      this.form.get('startDate').setValue(startDate)
      this.form.get('endDate').setValue(endDate)
      this.form.get('productId').setValue(targetProductId)
    }
  }

  public clearSelectedBookableSlot() {
    this.store.dispatch(bookableSlotActions.setSelected({ entity: null }))
    this.selectedBookableSlot = false
    this.form.get('bookingId').setValue(null)
    this.form.get('bookableProductId').setValue(null)
    this.form.get('startDate').setValue(null)
    this.form.get('endDate').setValue(null)
    this.resetForm$.next(true)
  }

  private fetchBookableSlots(
    startDate: Date,
    endDate: Date,
    productId: number
  ) {
    if (!productId || !startDate || !endDate) {
      return
    }

    this.store.dispatch(
      bookableSlotActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: {
            productIds: {
              [CondOperator.IN]: [productId]
            },
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString()
          },
          join: [
            //  { field: 'participations' },
            { field: 'product' },
            { field: 'linkedProduct' }
          ]
        })
      })
    )
  }

  private setupCalendarFetching() {
    combineLatest([
      this.selectedProduct$,
      this.isProductBookableOrActivity$,
      this.form
        .get('bookingOption')
        .valueChanges.pipe(startWith('showCalendar' as BookingOption))
    ])
      .pipe(
        filter(
          ([product, isProductBookableOrActivity, bookingOption]) =>
            product.id &&
            isProductBookableOrActivity &&
            bookingOption === 'showCalendar'
        ),
        distinctUntilChanged(
          (prev, curr) =>
            prev[0]?.id === curr[0]?.id &&
            prev[1] === curr[1] &&
            prev[2] === curr[2]
        ),
        untilDestroyed(this)
      )
      .subscribe(([product, isProductBookable, bookingOption]) => {
        this.fetchBookableSlots(
          new Date(),
          moment().add(7, 'days').toDate(),
          product.id
        )
      })
  }

  private setupCalendarEvents() {
    this.calendarEvents$ = combineLatest([
      this.selectedProduct$,
      this.store.select(bookableSlotSelectors.selectAll),
      this.store.select(participationSelectors.selectAll),
      this.productEntities$,
      this.store.select(bookingSelectors.selectEntities)
    ]).pipe(
      map(
        ([
          product,
          bookableSlots,
          participations,
          productEntities,
          bookingEntities
        ]) =>
          bookableSlots
            .filter(
              (b) =>
                (b.linkedProductId == 0 ||
                  b.linkedProductId == null ||
                  b.bookableProductId == product.id ||
                  b.linkedProductId == product.id ||
                  (b.bookingId
                    ? bookingEntities[b.bookingId]?.allowedLinkedProducts?.find(
                        (pId) => pId == product.id
                      )
                    : false) ||
                  product?.parentBookableProducts?.includes(b.group)) &&
                (!productEntities[b.linkedProductId]?.availableFromDate ||
                  moment(b.startDate).isSameOrAfter(
                    moment(
                      productEntities[b.linkedProductId]?.availableFromDate
                    )
                  ))
            )
            .map((bookableSlot) => {
              const participationsOfBooking = participations.filter(
                (p) => p.bookingId == bookableSlot.bookingId
              )

              return this.calendarService.mapBookableSlotToCalEvent(
                {
                  ...bookableSlot,
                  name: bookableSlot.linkedProductId
                    ? productEntities[bookableSlot.linkedProductId].description
                    : bookableSlot.bookableProductId
                      ? productEntities[bookableSlot.bookableProductId]
                          .description
                      : product.description
                },
                productEntities[bookableSlot.bookableProductId],
                productEntities[bookableSlot.linkedProductId],
                participationsOfBooking
              )
            })
      )
    )
  }
  private haveSelectedBookableSlot() {
    let exitSelectedBookableSlot: boolean = false
    this.selectedBookableSlot$?.pipe(take(1)).subscribe((sB) => {
      if (sB?.bookingId) {
        exitSelectedBookableSlot = true
      }
    })
    return exitSelectedBookableSlot
  }

  public getCategoryValue(categoryDescription: string): number {
    const regex = /\d+/

    return Number(categoryDescription.match(regex)?.[0])
  }

  public submitFromParent() {
    if (this.showSaveButton) {
      this.onFormSubmit()
      return
    }

    this.createBooking()
  }

  private emitFormState() {
    this.formStateChange.emit({
      canSubmit: !(
        this.form?.invalid ||
        this.isSurveyBlockingSave ||
        this.isLoading ||
        (this.bookingPreSelected && this.isLoading$.value)
      ),
      isLoading: Boolean(
        this.isLoading || (this.bookingPreSelected && this.isLoading$.value)
      ),
      submitLabelKey: this.showSaveButton ? 'general.save' : 'general.create',
      submitLabelSuffixKey: this.showSaveButton ? null : 'bookingModule.booking'
    })
  }
}
